import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const CustomAlert = ({open, setOpen, severity, message}) => {
    return(
        <Snackbar open={open} autoHideDuration={6000} onClose={() => setOpen(!open)}>
            <Alert onClose={() => setOpen(!open)} severity={severity} sx={{ width: '100%' }}>
                {message}
            </Alert>
        </Snackbar>
    )
}